module.exports = __webpack_public_path__ + "media/images/back_btn-8615794cf17c61dabeb8929715a1a051.png";